import { AddRowIcon, RemoveRowIcon } from 'assets/icons';
import * as React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { FieldLabel, RenderInput } from '../BaseInput';

export interface IFieldArrayInputProps extends IFieldArrayField {}

const FieldArrayItemContext = React.createContext({ name: '' });
FieldArrayItemContext.displayName = 'FieldArrayItemContext';
export function useFieldArrayItemName(fieldName: string) {
  const context = React.useContext(FieldArrayItemContext);

  return context && context.name ? context.name + '.' + fieldName : fieldName;
}

export function FieldArrayItemContextProvier({
  name,
  children,
}: {
  name: string;
  children: React.ReactNode;
}) {
  return (
    <FieldArrayItemContext.Provider value={{ name }}>
      {children}
    </FieldArrayItemContext.Provider>
  );
}
export default function FieldArrayInput(props: IFieldArrayInputProps) {
  const {
    name,
    dependencies,
    defaultDependency,
    effect,
    label,
    tooltip,
    dependenciesTitle,
  } = props;
  const methods = useFormContext();
  const { getValues, watch, control } = methods;

  const { fields, append, remove } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name, // unique name for your Field Array
    // keyName: "id", default to "id", you can change the key name
  });

  const watchFieldArray = watch(name);
  const controlledFields = (fields || []).map((field, index) => {
    return {
      ...field,
      ...watchFieldArray[index],
    };
  });

  React.useEffect(() => {
    // if (effect && getValues(name) !== null && getValues(name) !== undefined) {
    effect && effect({ key: name, value: getValues(name) });
    // }
  }, [watchFieldArray]);

  return (
    <div>
      <FieldLabel label={props.label} subLabel={props.subLabel} />
      <Accordion allowZeroExpanded preExpanded={[controlledFields[0]?.id]}>
        {controlledFields &&
          controlledFields?.map((field, index) => (
            <div key={field.id} className="flex items-start relative mb-4">
              <AccordionItem
                className="w-full rounded-lg overflow-hidden"
                uuid={field.id}
              >
                <AccordionItemHeading>
                  <AccordionItemButton>Record #{index + 1}</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  {dependencies?.map((dep, i) => (
                    <FieldArrayItemContextProvier
                      key={i}
                      name={`${name}.${index}`}
                    >
                      <RenderInput field={dep} />
                    </FieldArrayItemContextProvier>
                  ))}
                </AccordionItemPanel>
              </AccordionItem>
              {index >= 0 && (
                <div
                  className="cursor-pointer absolute top-0 right-0 flex items-center mt-4 mr-4"
                  onClick={() => {
                    remove(index);
                  }}
                >
                  <RemoveRowIcon className="w-4 h-full mr-2" />
                  <span className="text-sm text-gray-700">Remove Row</span>
                </div>
              )}
            </div>
          ))}
      </Accordion>
      <div className="w-full">
        <button
          onClick={() => append(defaultDependency)}
          type="button"
          className="px-6 w-full font-semibold flex rounded-lg h-14 border border-dashed border-gray-100 text-sm items-center"
        >
          <AddRowIcon className="mr-2" />
          Add New Row
        </button>
      </div>
    </div>
  );
}
